import React, { useEffect } from "react";
import { Button, Card, Label } from "reactstrap";
import IntlMessages from "../../helpers/IntlMessages";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { requestGetItem, setIsTranslationNeeded } from "../../redux/request/actions";
import MessageCard from "../../components/requests/MessageCard";
import ScrollButton from "../gotoTopScrollButton/ScrollButton";

const RequestChatSection = ({
  request,
  addCommentLoading,
  isTranslationNeeded,
  setIsTranslationNeeded,
  requestGetItem,
  locale,
  hotelConfig
}) => {

  useEffect(() => {
    setIsTranslationNeeded(false);
  }, [setIsTranslationNeeded]);

  const handleCommentsTranslation = () => {
    if (request.comments?.length > 0) {
      if (!isTranslationNeeded) {
        requestGetItem({
          request_id: request.id,
          isTranslationNeeded: !isTranslationNeeded
        });
      }
      setIsTranslationNeeded(!isTranslationNeeded);
    }
  };

  const getEmptyStateMessageCard = () => {
    if (!request.comments && !addCommentLoading) {
      return (
        <div style={{ textAlign: "center" }}>
          <i className="iconsminds-inbox-empty text-muted" style={{ fontSize: "25px" }} />
          <Label className="list-item-heading mb-2 text-muted">
            <IntlMessages id="request.empty_message_box" />
          </Label>
        </div>
      );
    }
  }

  const getCommentMessageCards = () => {
    let commentMessageCards = [];
    if (request.comments && request.comments.length) {
      commentMessageCards = request.comments.map((item, index) => {
        return (
          <MessageCard key={index}
            locale={locale}
            sender={{ name: item.author_name, thumb: "", text: item.body }}
            item={item}
            isTranslationNeeded={isTranslationNeeded}
            currentUserid={request.requester_id}
            bucket={`https://${hotelConfig.bucket}.s3.eu-west-1.amazonaws.com/public/`}
            file={item.attachments}
          />
        );
      });
    }

    if (addCommentLoading) {
      commentMessageCards.push(
        <MessageCard key={"loadingMessageCard"} item={{ is_staff: "true" }} isLoading />
      );
    }

    return commentMessageCards;
  }

  if (!request) return (<>Request Not Found</>);

  return (
    <Card className="question d-flex card-body pt-0" style={{ backgroundColor: "#e9ecef" }}>
      <div className="d-flex flex-grow-1 min-width-zero">
        <div className="card-body align-self-center d-flex flex-column flex-md-row 
        justify-content-between min-width-zero align-items-md-center"
        >
          <div className="list-item-heading mb-0 truncate w-80 mb-1 mt-1" />
        </div>
      </div>

      <Label className="list-item-heading mb-2 w-100 text-muted">
        <IntlMessages id="request.message_title" />
      </Label>

      <div className="separator mb-4" />

      <ul className="list-unstyled mb-4">
        <li>
          {getCommentMessageCards()}
          {getEmptyStateMessageCard()}
        </li>
      </ul>

      <div className="separator mb-3" />

      {request.comments && request.comments.length &&
        <div className="float-left">
          <Button type="button" color="outline-success" size="xs"
            className="btn outline-light flex-grow-1 "
            onClick={handleCommentsTranslation}
          >
            {isTranslationNeeded === false ? (
              <IntlMessages id="request.message_view_translation" />
            ) : (
              <IntlMessages id="request.message_show_original" />
            )}
          </Button>
        </div>
      }

      <ScrollButton />
    </Card>
  );
};

const mapStateToProps = ({ requestApp, settings }) => {
  const { isTranslationNeeded, addCommentLoading } = requestApp;
  const { locale, hotelConfig } = settings;

  return ({
    isTranslationNeeded, addCommentLoading, locale, hotelConfig
  })
};

const mapActionsToProps = {
  setIsTranslationNeeded,
  requestGetItem,
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapActionsToProps
  )(RequestChatSection)
);
